import { useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import { useEffect } from "react";

const Unsubscribe = () => {
    const {unsub} = useParams();
    useEffect(() => {
        fetch('https://api.voicecoach.net/uncollect', {
            headers: { 'Content-Type':'application/json' }, keepalive: true, method: 'POST', body: JSON.stringify({ _e: unsub })
        });
    })
    return <>
    <Header />
    <main className="container">
        <div className="row my-5">
            <div className="col-10 col-lg-2 mx-auto">
                <img src="/img/tick.svg" alt="successfully unsubscribed" className="w-100" />
            </div>
        </div>
        <div className="row">
            <div className="col-12 col-lg-10 mx-auto text-center">
        <p className="display-5">You are unsubscribed.</p>
        <p>Feel free to visit us or resubscribe whenever you like.</p>
        <p>We will be happy to welcome you back!</p>
        <p>All the best,<br />
        The Voice Coach Team</p>
        </div>
        <div className="col-12">
        <p><small>Copyright © 2023 The Voice Business (ABN 71 116 902 071), publishers of Voicecoach.net. All Rights Reserved.The Voice Business. P.O. Box 179,Crows Nest, NSW 1585, AU</small></p>
        </div>
        </div>
    </main>
    <Footer />
    </>
}

export default Unsubscribe;